import AdminEditShiftsForm from './admin';
import ClientEditShiftsForm from './client';
import ContractorEditShiftsForm from './contractor';

const tenants = {
    admin: AdminEditShiftsForm,
    client: ClientEditShiftsForm,
    contractor: ContractorEditShiftsForm
};

export default tenants;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/forms/editShifts/tenants/index.jsx